<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/video-heart.svg" width="50" alt="Minds" class="">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <div class="container">
          <h2 class="animation-top animation-delay-02">YOUR <span>SPEAK UP</span></h2>
          <div class="margin-left-20 margin-right-10 container aling-items-end animation-top animation-delay-04">
            <button style="color: rgb(196, 0, 60);" class="btn btn-sm btn-rounded gradient-yellow btn-padding" @click="$router.go(-1)">Voltar</button>
          </div>
        </div>
        <hr style="width: 167px;" class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Veja todas suas Speak Ups! </p>
      </div>
    </div>
    <div class="box-content shadow-box box-content-border">
      <list :data="speakups" />
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import list from '@/components/speakup/list'

  import { toArray } from '@/store/firebase'

  export default {
    computed: {
      ...mapGetters({
        _speakups: 'speakup/getSpeakUps'
      }),
      speakups () {
        return this._speakups.map((speakup, index) => {
          switch (index % 3) {
            case 0:
              speakup.cor1 = '#E12F67'
              speakup.cor2 = '#8D00FF'
              break
            case 1:
              speakup.cor1 = '#00F0FF'
              speakup.cor2 = '#6FBE15'
              break
            case 2:
              speakup.cor1 = '#FF9C00'
              speakup.cor2 = '#FF0000'
              break
            default:
              break
          }

          return speakup
        })
      }
    },
    components: {
      list
    },
    methods: {
      ...mapMutations({
        setShowLoader: 'setShowLoader'
      }),
      ...mapActions({
        getSpeakUps: 'speakup/getSpeakUps'
      })
    },
    async mounted () {
      this.setShowLoader(true)

      this.getSpeakUps()
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.setShowLoader(false)
        })
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/speakup/speakups.vue